<template>
  <div class="historic column">
    <div class="title row">
      <div class="grid-4">DATA</div>
      <div class="grid-6">MOTIVO</div>
      <div class="grid-2">STATUS</div>
    </div>
    <div
      v-for="row of modal.historic"
      :key="'h' + row.id"
      class="row line align-center"
    >
      <div class="grid-4">
        <b>
          {{ row.dh_pendencia | date }}
        </b>
      </div>
      <div class="grid-6">{{ row.motivo }}</div>
      <div class="grid-2">{{ row.status }}</div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  components: {  },
  props: { modal: Object },
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;
.historic {
  padding: 30px;
  width: 600px;
  overflow: auto;
  @media (max-width: $small) {
    width: inherit;
  }
  .line {
    border-radius: 3px;
    padding: 12px 9px;
    &:nth-child(even) {
      background: $white-9;
    }
  }
  .title {
    font-weight: bold;
    height: 30px;
    color: $gray-6;
    font-size: 14px;
  }
}
</style>